// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

let galleryTop = new Swiper('.mainpage-slider__swipe', {
    spaceBetween: 5,
    loop: true,
    loopedSlides: 1, //looped slides should be the same
    autoplay: {
        delay: 4000,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
    }
});